var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadarActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#059a0a",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M437.02,74.981C388.667,26.629,324.38,0,256,0S123.333,26.629,74.981,74.981C26.628,123.332,0,187.62,0,256 S26.628,388.668,74.981,437.02C123.333,485.371,187.62,512,256.001,512c68.381,0,132.668-26.629,181.019-74.98 C485.371,388.668,512,324.38,512,256S485.371,123.333,437.02,74.981z M415.512,415.512 c-42.606,42.606-99.256,66.071-159.511,66.071c-60.256,0-116.905-23.465-159.511-66.071C53.883,372.905,30.417,316.255,30.417,256 S53.882,139.096,96.49,96.489C139.097,53.881,195.745,30.417,256,30.417c55.157,0,107.285,19.674,148.393,55.682l-41.209,41.209 C333.145,102.201,295.626,88.522,256,88.522c-92.347,0-167.476,75.13-167.476,167.477S163.654,423.477,256,423.477 s167.477-75.131,167.477-167.477h-30.417c0,75.575-61.485,137.06-137.06,137.06S118.942,331.575,118.942,256 S180.426,118.94,256,118.94c31.491,0,61.355,10.557,85.569,29.983l-41.528,41.528c-12.914-8.716-28.116-13.405-44.041-13.405 c-43.535,0-78.953,35.419-78.953,78.953c0,43.534,35.418,78.953,78.953,78.953s78.953-35.419,78.953-78.953h-30.417 c0,26.763-21.774,48.536-48.536,48.536S207.465,282.762,207.465,256c0-26.762,21.773-48.536,48.536-48.536 c7.716,0,15.152,1.802,21.845,5.183l-32.599,32.599l21.508,21.508l159.147-159.147c36.008,41.109,55.682,93.236,55.682,148.392 C481.583,316.255,458.118,372.904,415.512,415.512z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 396.712,
    cy: 197.712,
    r: 18.423
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadarActive);
export default __webpack_public_path__ + "static/media/radar_active.cf313b3d580d74618f758638d27e1466.svg";
export { ForwardRef as ReactComponent };